import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient for the app. Tuned for an SPA where most data is
 * "give me the freshest snapshot when the user lands on a route":
 *
 * - staleTime 30s — refetches on window focus only after 30s of staleness,
 *   not on every focus (cheap network savings, fine for our content).
 * - gcTime 5min — keeps cached data around long enough that browser-back
 *   feels instant.
 * - retry 1 — second chance on transient network blips, no exponential
 *   storms on a real outage.
 * - refetchOnWindowFocus true — picks up server-side edits made by
 *   collaborators, since we don't have realtime in v2.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
